export default {"src":"/_next/static/media/dark-instagram-icon.d6e1c26b.svg","height":28,"width":28};